module.exports = "<ul>\n  <li *ngFor=\"let soundInBeat of childSingleBeat; let j = index\" [attr.data-index]=\"j\">\n    <button type=\"button\" (click) =\"toggle(j)\">\n      <img [src]=\"childSingleBeat[j].switchImg\">\n      <audio id=\"sound-{{childSingleBeatIndex}}-{{j}}\">\n        <source [src]=\"childSingleBeat[j].soundFile\" type=\"audio/mpeg\">\n          Your browser does not support the audio element.\n      </audio>\n    </button>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/edit-sound/edit-sound.component.html
// module id = ../../../../../src/app/edit-sound/edit-sound.component.html
// module chunks = main